import * as types from '../../actions/types'

var Buffer = require('buffer/').Buffer

const initialState = {
  files: [],
  allFiles: []
}

export function attachmentReducer(state = initialState, action = {}) {

  switch (action.type) {
    case types.BUFF_RECEIVED:
      let fileName = action.payload.fileName
      let buff = action.payload.buff
      let p = action.payload.p

      let tmp = state.files.filter(el => el.fileName === fileName)
      tmp = tmp.length && tmp[0]

      return Object.assign({}, state, {
        files: [
          ...state.files.filter(el => el.fileName !== fileName),
          {
            fileName: fileName,
            p: p,
            buff: tmp.buff ? [...tmp.buff, Buffer.from(buff)] : [Buffer.from(buff)]
          }
        ]
      })
    case types.ALL_FILES_RECEIVED:
      return Object.assign({}, state, { allFiles: action.payload });
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/chat/attachmentReducer.js